// Menu principal (cabeçalho e atalhos da Home). Ícones só para os atalhos.
// Ordem dos itens definida pelo Altamir em 05/10/2026.
export const NAV_ROUTES = [
  {
    title:"Controle Leiteiro", 
    subRoutes:[
      {name:"Serviços", path:"Services-list", icon:"mdi-clipboard-text-outline"},
      {name:"Composição do Leite", path:"Milk-analysis-list", icon:"mdi-flask-outline"},
      {name:"Controle de Parto", path:"Birth-list", icon:"mdi-calendar-heart"},
      {name:"Encerramentos", path:"Closures-list", icon:"mdi-flag-checkered"},
      {name:"Registrar Baixas", path:"Kill-list", icon:"mdi-close-octagon-outline"}
    ]
  },
  {
    title:"Cadastro",
    subRoutes:[
      {name:"Criadores", path:"Creators-list", icon:"mdi-account-group-outline"},
      {name:"Propriedades", path:"Farms-list", icon:"mdi-barn"},
      {name:"Animais", path:"Animals-list", icon:"mdi-cow"},
      {name:"Controladores", path:"Partners-list", icon:"mdi-account-hard-hat"},
    ]
  },
  {
    title:"Relatórios",
    path:"/reports",
    icon:"mdi-chart-box-outline"
  }
];

// Menu por perfil (sistema do Rapha): admin vê tudo; criador só Serviços (consulta, N2);
// os demais veem os cadastros conforme as roles. Menu sem itens some.
export function visibleNav(user) {
  const attrs = (user && user.attributes) || {};
  const roles = ((user && user.roles) || []).map(e => e.name);
  const needs = {"Animals-list":"animals.create", "Partners-list":"partners.create", "Creators-list":"creators.create", "Farms-list":"creators.create"};
  const canSee = sub => attrs.kind === "admin" ||
    (attrs.kind === "creator" ? sub.path === "Services-list" : !needs[sub.path] || roles.includes(needs[sub.path]));
  return NAV_ROUTES
    .map(nav => nav.subRoutes ? {...nav, subRoutes: nav.subRoutes.filter(canSee)} : nav)
    .filter(nav => nav.subRoutes ? nav.subRoutes.length : attrs.kind !== "creator");
}
